import fetch from "@/common/utils/serFetch";
import fetchPub from '@public/http/request'
import { APICUS } from "@public/utils/const";
import { GATEWAYSER } from "@/common/config/index";

const moduleList = {
  workOrderManage: `${APICUS}/workOrder`,
  ResendPickupCode: `${APICUS}/receiveCode`, //重发取件码
  workOrder: `${APICUS}/workOrder`,
  record: `${GATEWAYSER.CSSPDD}/customerServiceRecord`, // 在线客服会话
  thirdService: `${APICUS}/thirdService`, // 物流轨迹
  customerSession: `${GATEWAYSER.SQSIM}/customerSession`
};

// 在线客服 成员管理 => 在线客服登录
export const ServicerLogin = {
  signIn: (reqData) => fetch.post(`${APICUS}/add`, reqData),
  signOut: (reqData) => fetch.post(`${APICUS}/signOut`, reqData),
  getCurrentDayReceptionNum: () =>
    fetch.get(`${APICUS}/getCurrentDayReceptionNum`),
};
// 工单管理 => 录单
export const RecordSheet = {
  checkCainiaoStation(params) {
    return fetch.post(`${moduleList.ResendPickupCode}/checkCainiaoStation`, params)
  },
  // 获取工单话术
  getfastWordsList: (params) =>
    fetch.get(`${APICUS}/workOrderInputWords/page`, { params }),
  // 获取运单详情
  getWaybillDetail(waybillNo) {
    return fetch.get(
      `${APICUS}/thirdService/waybill/commonWaybillListByWaybillNos?waybillNos=${waybillNo}`
    );
  },
  // 获取运单列表
  reqWaybillList(params) {
    return fetch.post(
      `${APICUS}/workOrderInputWords/getWorkOrderPages`,
      params
    );
  },
  // 获取运单来源
  reqRepository(wayBillNo) {
    return fetch.get(
      `${moduleList.workOrder}/queryChannelByWaybillNo?wayBillNo=${wayBillNo}`
    );
  },
  // 获取来电归属地
  reqCustomerAddress(phone) {
    return fetch.get(
      `${moduleList.workOrder}/queryProvinceCityByPhone?mobilePhone=${phone}`
    );
  },
  // 获取标签
  queryByPhone(phone,modelType) {
    return fetch.get(
      `${APICUS}/highRiskUser/queryByPhone?phone=${phone}&modelType=1`
    );
  },
  // 物流跟踪
  traceDataList(waybillNo, isAllPod) {
    return fetch.get(
      `${APICUS}/thirdService/ops/podTrackingList?isAllPod=${
        isAllPod ? 1 : 2
      }&waybillNos=${waybillNo}`
    );
  },
  // 物流跟踪180天
  keywordList(params) {
    return fetchPub.post(
      `${moduleList.keywordList}/inner/query/keywordList`,
      params
    );
  },
  // 获取录单一级类型
  getFirstType() {
    return fetch.get(`${firstTypeUrl}?isEnable=1`);
  },
  // 获取录单一级类型
  getFirstInputType() {
    return fetch.get(`${firstInputTypeUrl}?isEnable=1`);
  },
  // 获取录单二级类型
  getSecondType({ id, waybillNo, historyType = 1, channelName }) {
    return fetch.get(
      `${APICUS}/workOrderType/list/transferWorkOrderSecondTypes?isEnable=1&firstId=${id}&waybillNo=${waybillNo}&historyType=${historyType}&channelName=${channelName}`
    );
  },
  // 获取录单基础数据
  getInfoByInput: (reqData) =>
    fetch.post(`${APICUS}/workOrder/getInfoByInput`, reqData),

  // 新增工单
  reqSave(reqData) {
    return fetch.post(`${APICUS}/workOrder/save`, reqData);
  },
  // 工单催单
  reqReminder(reqData) {
    return fetch.post(`${APICUS}/workOrder/processBySave`, reqData);
  },
  // 校验工单是否存在
  reqWorkOrder(params) {
    return fetch.get(`${APICUS}/getWorkOrder`, { params });
  },
  // 通过网点编码获取责任网点信息
  reqResponsibleNetwork(params) {
    return fetch.get(`${APICUS}/responsibleNetworkCode?` + params);
  },
  // 通过网点编码获取网点列表
  getAcceptNetwork(reqData) {
    return fetch.post(`${APICUS}/getAcceptNetworkByType`, reqData);
    // return fetch.post(`${APICUS}/getAcceptNetwork`, reqData)
  },
  // 根据员工code客服详情(或者分机号和声通技能组)
  reqServiceStaff(params) {
    return fetch.get(`${APICUS}/customerServiceStaff/detail`, {
      params,
    });
  },
  // 工单处理全部记录列表
  reqAllProblemList(waybillNo) {
    return fetch.post(
      `${APICUS}/workOrder/getProblemRecords?waybillNo=` + waybillNo
    );
  },
  // 获取来电次数
  getInfoByMobile(params) {
    return fetch.get(`${APICUS}/workOrder/getInfoByMobile`, {
      params,
    });
  },
  // 获取录单场景默认一二级类型
  getDefaultByInput(params) {
    return fetch.get(`${APICUS}/workOrderType/getDefaultByInput`, {
      params,
    });
  },
  // 物品类型
  reqSrticle(params = {}) {
    params.size = params.size || 5000;
    return fetch.get(`${APICUS}/article/select`, { params });
  },
  // 预估费用
  getEstimatedFreight(params) {
    return fetch.get(
      `${moduleList.workOrderManage}/getEstimatedFreight`,
      { params }
    );
  },
  // 网点查询
  getNetworkInfor(params) {
    return fetch.get(
      `${moduleList.workOrderManage}/getNetworkInfor`,
      { params }
    );
  },
  // 新增来电号码记录
  addCallRecord(reqData) {
    return fetch.post(
      `${moduleList.workOrderManage}/addCallRecord`,
      reqData
    );
  },
  // 获取当前在线客服接待会话状态
  getSessionId(params) {
    return fetch.post(
      `${APICUS}/customerServiceRecord/getSessionId`,
      params
    );
  },
  // 百世请求物流轨迹
  getQueryBs(reqData) {
    return fetch.post(`${APICUS}/bs/queryBillTrace`, reqData);
  },
  // 重发取件码
  ResendPickupCode(params) {
    return fetch.post(
      `${moduleList.ResendPickupCode}/retransmission`,
      params
    );
  },
  // 百世基础信息
  queryBillBs(reqData) {
    return fetch.post(`${APICUS}/bs/queryBillDecryption`, reqData);
  },
  // 来电手机日志
  phoneRecord(reqData) {
    return fetch.post(
      `${moduleList.workOrderManage}/phoneRecord`,
      reqData
    );
  },
  // 根据订单查询基础信息
  getOmsOrderById(reqData) {
    return fetch.get(
      `${moduleList.thirdService}/getOmsOrderById?orderId=${reqData}`
    );
  },
  // 根据订单获取运单信息
  getInfoByOrderId(reqData) {
    return fetch.post(
      `${moduleList.workOrderManage}/getInfoByOrderId`,
      reqData
    );
  },
  // 查询来电记录
  getCallRecord(reqData) {
    return fetchPub.post(
      `${moduleList.workOrder}/queryCallRecord`,
      reqData
    );
  },
  // 来电记录脱敏
  getPhoneNumber(reqData) {
    return fetch.post(
      `${moduleList.workOrder}/queryMobilePhone`,
      reqData
    );
  },
  // 根据手机号码查询订单信息
  queryOrderPhone(reqData) {
    return fetch.post(`${moduleList.thirdService}/queryOrderByPhone`, reqData);
  },
   // 是否为总部vip
   reqIsHQVIP() {
    return fetch.get(`${moduleList.workOrder}/getVipTransferSwitch`)
  },
  reqConsolidation: (waybillNo) => fetch.get(`${moduleList.thirdService}/isConsolidation/waybillNo?waybillNo=${waybillNo}`),
  // 异常客服编号提示
  getCustomerExc: (reqData) => fetch.get(`${APICUS}/networkAbnormalInformation/isCustomerException?waybillNo=${reqData}`),
    // 网点异常管理--异常运单详情
    getNetWaybill: (waybillNo) => fetch.get(`${APICUS}/networkAbnormalWaybill/isExceptionWaybill?waybillNo=${waybillNo}`),
  // 根据地址获取运单信息
  getInfoByAddress: (reqData) => fetch.post(`${moduleList.workOrder}/getInfoByAddress`, reqData),
   // 脱敏
  getPhoneDetail(id) {
    return fetch.get(`${moduleList.customerSession}/phone/decrypt?sessionId=${id}`)
  },
  // 录单新接口 在线
  saveByOnline: (reqData) => fetch.post(`${moduleList.workOrder}/saveByOnline`, reqData),
  // 录单新接口 热线
  saveByHotline: (reqData) => fetch.post(`${moduleList.workOrder}/saveByHotline`, reqData),
  // 7. 工单小计
getSessionWorkOrderSuggestOld(sessionId,waybillNo,customerPhone) {
  return fetch.get(`/ylwebsqsserviceonline/aiAssistant/getSessionWorkOrderSuggest?sessionId=${sessionId}&webWaybillNo=${waybillNo}&webPhoneNumber=${customerPhone}`)
},
getSessionWorkOrderSuggest(params) {
  return fetch.post(`/ylwebsqsserviceonline/agent/session/ai/workOrderRecommend`, params)
},
getSessionWorkOrderSuggestNew(sessionId) {
  return fetch.get(`ylwebsqsserviceonline/agent/session/ai/getWorkOrderRecommend?sessionId=${sessionId}`)
},
getSubtotalWorkOrderEnable() {
  return fetch.get(`/ylwebsqsserviceonline/aiAssistant/getSubtotalWorkOrderEnable`,)
},
// 工单小结点击率
reqAiWorkOrderSummaryRecord: params => fetch.post(`/ylwebsqsserviceonline/aiWorkOrderSummaryRecord/add`, params),
reqUpdateAiWorkOrderSummaryRecord: params => fetch.post(`/ylwebsqsserviceonline/aiWorkOrderSummaryRecord/adopt`, params),
// 详情工单信息 明文
reqOrderInfoPlaintext(params) {
  return fetch.get(`${APICUS}/integration/getWaybillsByReverse`, { params })
},
getSwitchDamaged() {
  return fetch.get(`/ylwebsqsserviceonline/agent/getGrayscaleSwitch`)
}
};
// 一级类型列表获取， 接口缓存无分页
export const firstTypeUrl = `${APICUS}/workOrderType/list/workOrderFirstType`;
// 一级类型列表获取， 接口缓存无分页
export const firstInputTypeUrl = `${APICUS}/workOrderType/input/workOrderFirstType`;
// er级类型列表获取， 接口缓存无分页
export const secondTypeUrl = `${APICUS}/workOrderType/list/workOrderSecondType`;
//炫米登录
export const xuanMiCall = {
  getToken: params => fetch.get(`${APICUS}/customerServiceStaff/xuanMi/getToken`, { params }),
  // 炫米记录客服接听
  addListen: params => fetch.post(`${moduleList.workOrderManage}/addListen`, params),
  // 炫米记录客服接听量接口
  queryListen: params => fetch.post(`${moduleList.workOrderManage}/queryListen`, params),

}
